export const TEMPO_MAXIMO_BORDERO_FIELD_TITLE = 'Tempo máximo de permanência antes da exclusão definitiva';
export const PRAZO_RETENCAO_LOG_TITLE = 'Prazo de Retenção Log Borderô';
export const CONFIGURACAO_BORDERO_TITLE = 'Configuração de Borderôs';
